const { getRequest, postRequest, getDetailRequest } = require("./axiosRequest");

const url = `${process.env.REACT_APP_SERVER_URI}/api/v1/device`;

export const getDevice = (param) => getRequest(url, param);
export const getDeviceDetail = (param) => getDetailRequest(url, param);
export const linkDevice = (body) => postRequest(`${url}/link`, body);
export const postUseDevice = (body) => postRequest(`${url}/use`, body);
export const postControlDevice = (body) => postRequest(`${url}/control`, body);
// export const getPatientCount = (param) => getRequest(`${url}/count`, param);
